<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content facilities">
			<div class="row align-center">
				<div class="columns column12">
					<div class="hotel-icons">
						<div v-if="defaults[locale].hotelInformation.iconWifi" class="icon-holder">
							<font-awesome-icon icon="fal fa-wifi" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconWifi }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconParking" class="icon-holder">
							<font-awesome-icon icon="fal fa-circle-parking" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconParking }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconChargingStation" class="icon-holder">
							<font-awesome-icon icon="fal fa-charging-station" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconChargingStation }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconBicycle" class="icon-holder">
							<font-awesome-icon icon="fal fa-bicycle" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconBicycle }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconDog" class="icon-holder">
							<font-awesome-icon icon="fal fa-dog-leashed" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconDog }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconWheelchair" class="icon-holder">
							<font-awesome-icon icon="fal fa-wheelchair" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconWheelchair }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconTaxi" class="icon-holder">
							<font-awesome-icon icon="fal fa-taxi" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconTaxi }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconRestaurant" class="icon-holder">
							<font-awesome-icon icon="fal fa-fork-knife" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconRestaurant }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconBar" class="icon-holder">
							<font-awesome-icon icon="fal fa-champagne-glasses" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconBar }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconTerrace" class="icon-holder">
							<font-awesome-icon icon="fal fa-bench-tree" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconTerrace }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconCampfire" class="icon-holder">
							<font-awesome-icon icon="fal fa-champagne-glasses" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconCampfire }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconHiking" class="icon-holder">
							<font-awesome-icon icon="fal fa-person-hiking" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconHiking }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconBiking" class="icon-holder">
							<font-awesome-icon icon="fal fa-person-biking" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconBiking }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconDeer" class="icon-holder">
							<font-awesome-icon icon="fal fa-deer" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconDeer }}</span>
						</div>
						<div v-if="defaults[locale].hotelInformation.iconSpa" class="icon-holder">
							<font-awesome-icon icon="fal fa-spa" size="1x" />
							<span>{{ defaults[locale].hotelInformation.iconSpa }}</span>
						</div>
					</div>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:items="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();
</script>

<style lang="scss" scoped>
.facilities {
	padding: 0 0 75px;
}

.hotel-icons {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;
	margin: 0 0 40px;
	gap: 20px;
}

.icon-holder {
	margin: 15px 0;
	display: flex;
	flex-flow: column wrap;
	justify-content: center;
	align-items: center;
	text-align: center;
	width: auto;
	min-width: 12%;

	svg,
	i {
		margin: 0 0 20px;
		font-size: 30px;
		color: $button-nofill-color;
	}
}

@media (max-width: 680px) {
	.hotel-icons {
		gap: 0;
	}

	.icon-holder {
		width: 48%;
		margin: 25px 1%;
	}
}
</style>
